export const translations = {
  en: {
    nav: {
      about: "About Us", mission: "Mission", whatWeDo: "What We Do", roadmap: "Roadmap",
      nqm: "NQM Hub", contact: "Contact", demo: "Request a Demo", news: "News",
    },
    news: {
      eyebrow: "Cyber News Desk",
      titleA: "India's cyber frontline, ", titleB: "tracked live.",
      sub: "Curated by our automated news agent from Indian and global sources — refreshed every 48 hours.",
      readMore: "Read full story", tickerLabel: "Latest Cyber News",
      filterAll: "All news", filterQuantum: "Quantum only",
      updatedA: "Updated", refreshNote: "auto-refreshes every 48h",
      mAgo: "m ago", hAgo: "h ago", dAgo: "d ago",
      empty: "News is being fetched — check back shortly.",
    },
    hero: {
      badge1: "Aligned to India's National Quantum Mission",
      badge2: "Trust for the Quantum Era",
      l1: "Are you safe from", l2: "tomorrow's digital threats?", l3: "Is your quantum defense ready?",
      sub: "QSafe India resells and deploys Post-Quantum Cryptography software and Quantum Key Distribution hardware — preparing Government departments, Defence, PSUs and private enterprises for the digital threats of the quantum era.",
      cta1: "Explore Quantum Solutions", cta2: "NQM Compliance Brief",
      s1v: "National Quantum Mission outlay", s2v: "FIPS 203 / 204 / 205 aligned", s3v: "PSUs, ministries & private enterprises",
    },
    cd: {
      badge: "India's Quantum-Safe Deadline",
      title: "Countdown to Q-Day · ~2030",
      years: "Years", days: "Days", hours: "Hours", mins: "Min", secs: "Sec",
      bodyA: "A conservative estimate of when a quantum computer breaks today's encryption. India's critical infrastructure must be quantum-resilient by ",
      bodyB: "2029",
      bodyC: " (DST advisory). Nobody knows the exact date — ",
      bodyD: "that is the point.",
      link: "See India's roadmap ahead",
    },
    marquee: {
      items: ["TRUST FOR THE QUANTUM ERA", "NATIONAL QUANTUM MISSION ALIGNED", "POST-QUANTUM CRYPTOGRAPHY", "QKD HARDWARE RESALE", "PSU & DEFENCE COMPLIANT", "PRIVATE SECTOR READY", "MEITY PROTOCOLS", "ZERO-TRUST QUANTUM MESH"],
    },
    about: {
      eyebrow: "About QSafe India",
      titleA: "The bridge between quantum innovation and ",
      titleB: "India's public & private sectors.", titleC: "",
      sub: "QSafe India exists for one purpose: to carry world-class quantum security from the laboratory into the networks that run the nation. We are a specialist reseller and integration partner serving Government ministries, Defence establishments, Public Sector Undertakings and private enterprises. Trust for the quantum era.",
      p1t: "Authoritative OEM Reseller",
      p1d: "Certified channel partner for indigenous and global quantum-security OEMs — QKD systems, HSMs and PQC software suites for public and private sector networks.",
      p2t: "Seamless Procurement",
      p2d: "GeM-portal ready with PSU tender expertise and RFP drafting support for government buyers — plus fast, flexible commercial engagement for private enterprises.",
      badgeA: "NQM horizon we", badgeB: "are building toward",
    },
    mission: {
      eyebrow: "Our Mission",
      titleA: "A manifesto for a ", titleB: "quantum-safe Bharat.", titleC: "",
      sub: "Four commitments that govern everything QSafe India resells, deploys and defends — written for the decade of the National Quantum Mission.",
      chapter: "Chapter",
      ch: [
        { title: "Sovereign Cryptographic Immunity", desc: "Shield India's strategic assets — power grids, defence networks, financial rails — from harvest-now-decrypt-later attacks before Q-Day arrives." },
        { title: "Indigenous QKD Hardware Access", desc: "Put certified fibre and free-space Quantum Key Distribution systems within reach of every PSU through transparent, compliant resale channels." },
        { title: "Phased NQM 2031 Migration", desc: "Operationalise NIST-approved post-quantum algorithms across critical information infrastructure on a measured, auditable roadmap." },
        { title: "Zero-Trust Quantum Mesh", desc: "Weave ministries, PSUs and defence commands into unbreakable quantum-secured communication networks — resilient by design." },
      ],
    },
    wwd: {
      eyebrow: "What We Do",
      titleA: "Two disciplines. One outcome: ", titleB: "quantum resilience.",
      sub: "Every engagement pairs certified hardware and software from our OEM partners with the procurement fluency India's public and private sectors demand.",
      c1t: "QKD Hardware Reselling",
      c1d: "Turnkey resale and deployment of Quantum Key Distribution systems for Power, Energy and Defence PSUs — and for private data-centre, telecom and BFSI operators. Fibre-based and free-space links, trusted-node architectures, installation and AMC support included.",
      c2t: "PQC Software Suites",
      c2d: "Post-quantum cryptography libraries, API gateways and VPN overlays implementing NIST FIPS 203/204/205 algorithms — deployable across government estates and private enterprise infrastructure alike.",
    },
    roadmap: {
      eyebrow: "India Roadmap Ahead",
      titleA: "Two tracks. One ", titleB: "quantum-safe nation.",
      sub: "India's DST Task Force (May 2026) lays out the nation's first consolidated PQC migration roadmap — an accelerated track for critical infrastructure and a standard track for government and private enterprises. QSafe India equips both.",
      threats: [
        "Q-Day warning — quantum computers may break today's public-key cryptography within three years (IonQ CEO, Davos 2026, cited in the DST report)",
        "of executives expect quantum-enabled cyberattacks within five years — most organisations have no plan (Bain & Co.)",
        "Harvest-Now-Decrypt-Later and Trust-Now-Forge-Later — data encrypted today is already at risk",
      ],
      cii: {
        label: "CII Track",
        desc: "Accelerated migration for Critical Information Infrastructure — Defence, Power, Telecom, ISRO, DRDO, ONGC, Banking Core.",
        milestones: [
          { title: "Inventorisation, QRA & Pilots", points: ["Stand up quantum governance & cross-functional teams", "Crypto inventory + CBOM disclosure from suppliers", "Quantum Risk Analysis using Mosca's Theorem", "Sandbox pilots for high-priority systems"] },
          { title: "High-Priority Resiliency", points: ["No new classical-only deployments", "PQC/hybrid PKI certificates & signatures", "Upgrade HSMs, KMS and crypto libraries", "CBOM mandated from all vendors"] },
          { title: "Complete Quantum Resiliency", points: ["Enterprise-wide PQC/hybrid transition", "PQC-only internal trust chains", "All digital signatures on PQC algorithms", "Continuous assurance & crypto-agility"] },
        ],
      },
      ent: {
        label: "Enterprise Track",
        desc: "Standard timeline for government departments and private enterprises beyond critical infrastructure.",
        milestones: [
          { title: "Inventorisation, QRA & Pilots", points: ["Leadership, crypto inventory & prioritisation", "Begin migration of high-priority systems"] },
          { title: "High-Priority Resiliency", points: ["Institutionalise crypto-agility", "Mandate CBOM from vendors"] },
          { title: "Complete Quantum Resiliency", points: ["Whole-of-enterprise PQC adoption", "Sustained assurance & continual agility"] },
        ],
      },
      tiersTitle: "Not all organisations face the same urgency",
      tiers: [
        { title: "Urgent Adopters (CII)", desc: "Longest data shelf life and slowest refresh cycles — existential exposure to quantum-capable adversaries." },
        { title: "Regular Adopters (Enterprise)", desc: "Moderate risk windows but large attack surfaces and diverse vendor ecosystems." },
        { title: "Technology Vendors", desc: "The supply-side linchpin — without PQC-ready products, no adopter can migrate. CBOM submissions advised from FY 2027–28." },
      ],
      fitLabel: "Where QSafe India fits",
      fitBody: "Whether you operate critical infrastructure on the 2027–2029 track or run a private enterprise on the 2028–2033 track, we supply the certified QKD hardware, PQC software and procurement expertise to keep you ahead of every milestone.",
      fitCta: "Plan Your Migration",
      statsV: ["NQM budget 2023–2031", "IISc · IIT-M · IIT-B · IIT-D", "researchers · 43 institutions", "NIST standards: FIPS 203/204/205 + 206 draft"],
      disclaimer: "Summary based on \"Implementation of Quantum Safe Ecosystem in India: Report of the Task Force\", Department of Science & Technology, Government of India (May 2026). The roadmap is advisory; binding obligations apply through sector regulators.",
    },
    nqm: {
      eyebrow: "National Quantum Mission Hub",
      titleA: "India's quantum decade — ", titleB: "mapped.",
      sub: "The NQM commits ₹6,003.65 crore (2023–2031) to make India a quantum leader. Here is what it means for your organisation, and how ready you are.",
      timeline: [
        "Cabinet approves National Quantum Mission — ₹6,003.65 Cr outlay, chaired under DST.",
        "Four T-Hubs operational: IISc, IIT Madras, IIT Bombay, IIT Delhi.",
        "Inter-city QKD pilots over trusted-node fibre; PQC migration guidelines for CII.",
        "50–100 qubit systems targeted; satellite QKD ground stations commissioned.",
        "Quantum-secure networks span 2,000 km; mission horizon concludes.",
      ],
      facts: [
        { title: "MeitY & CERT-In Direction", desc: "Advisories urge ministries and CII operators to inventory cryptography and plan PQC migration ahead of cryptographically relevant quantum computers." },
        { title: "Four Thematic Hubs", desc: "Quantum Computing (IISc), Quantum Communication (IIT Madras), Quantum Sensing (IIT Bombay) and Quantum Materials (IIT Delhi) anchor the mission." },
      ],
      calc: {
        title: "Quantum Readiness Score",
        desc: "Select your sector and current posture to estimate your organisation's quantum readiness.",
        sectorLabel: "Sector",
        sectors: ["Defence & Strategic", "Power & Energy", "Banking & Finance", "Telecom", "Transport & Railways"],
        posture: ["We maintain a Cryptographic Bill of Materials (CBOM)", "Keys are already held in certified HSMs", "A PQC / QKD pilot is underway or budgeted"],
        button: "Calculate My Score",
        critical: "CRITICAL EXPOSURE", transitioning: "TRANSITIONING", ready: "QUANTUM-READY TRAJECTORY",
        note: "Indicative estimate only. Talk to QSafe India for a formal CBOM-backed assessment.",
      },
      mosca: {
        title: "Mosca's Inequality",
        desc: "The math of being late. If X + Y > Z, the window to protect today's data has already closed.",
        xLabel: "X · Data shelf life (years)",
        yLabel: "Y · Migration time (years)",
        zLabel: "Z · Years until Q-Day (~2030)",
        vs: "vs",
        risk: "WINDOW CLOSED — START NOW",
        safe: "WINDOW OPEN — FOR NOW",
        note: "Drag the sliders: how long must your data stay secret, and how long will migration realistically take?",
      },
    },
    contact: {
      eyebrow: "Contact Us",
      titleA: "Start your ", titleB: "quantum-safe journey.", titleC: "",
      sub: "Tell us your requirement — hardware, software or tender support — and our liaison desk will respond within one working day, whether you are a PSU, a ministry or a private enterprise.",
      name: "Full Name", email: "Official Email", org: "Organisation Type", needs: "Requirement Areas", message: "Brief Requirement / RFP Reference",
      namePh: "Dr. Ananya Sharma", emailPh: "name@organisation.com",
      msgPh: "e.g. QKD link between two data centres over 40 km existing fibre…",
      orgs: ["PSU", "Defence", "Ministry / Department", "R&D Institute", "Private Enterprise"],
      needsList: ["QKD Hardware", "PQC Software", "RFP Assistance", "Private Network Security"],
      submit: "Submit Requirement",
      toast: "Requirement registered — our team will reach out shortly.",
      error: "Something went wrong — please try again.",
      successTitle: "Requirement received.",
      successA: "Thank you, ", successB: ". Our team will contact you at ", successC: " soon.",
      reset: "Submit another requirement",
      officeTitle: "Sales Office",
      addr: ["QSafe India Pvt. Ltd.", "Sector 30, Gurgaon,", "Haryana — 122002"],
      helpdesk: "Contact: +91 98100 32815",
      respLabel: "Response Commitment",
      respBody: "All government, PSU and private-sector enquiries answered within one working day. Classified requirements handled through secure channels on request.",
      gemLabel: "GeM Registered Reseller",
      gemBody: "Listed on the Government e-Marketplace for direct procurement by ministries, departments and PSUs — with commercial terms for private enterprises.",
    },
    legal: {
      eyebrow: "Legal",
      titleA: "Disclaimer & ", titleB: "Limitation of Scope",
      sub: "The terms under which QSafe India operates — acknowledged by every visitor before entering this site.",
      note: "This disclaimer is displayed to every visitor on arrival and forms part of the terms of use of this website. For contractual or compliance queries, write to office@qsafeindia.com.",
    },
    disclaimer: {
      title: "Disclaimer & Limitation of Scope",
      clauses: [
        { title: "Nature of Business & Non-Manufacturing Clause", body: "QSafe India operates exclusively as an authorized strategic business consultancy and sales intermediary. We do not engage in the proprietary design, development, engineering, or manufacturing of any hardware, software, or cryptographic products." },
        { title: "Principal-Agent Operations", body: "Our business operations are strictly governed by binding commercial contracts, channel partnership agreements, and non-disclosure agreements (NDAs) with primary Original Equipment Manufacturers (OEMs) and principal cybersecurity technology developers. We act solely as authorized sales consultants to facilitate client acquisition, market penetration, and technology deployment on behalf of our principal partners across both public (B2G) and private (B2B) sectors." },
        { title: "Strategic Alignment & Mission", body: "Our corporate mandate is fundamentally aligned with the Government of India's National Quantum Mission (NQM) and allied national cybersecurity directives. We are dedicated to facilitating the adoption of future-ready, quantum-safe cryptographic solutions across critical infrastructure and commercial enterprises to ensure long-term digital resilience." },
      ],
      agree: "I Agree & Continue",
      note: "This acknowledgement is requested each time you visit.",
    },
    footer: {
      tagline: "Trust for the Quantum Era",
      body: "QSafe India resells and deploys quantum security software and hardware for Government, Defence, Public Sector Undertakings and private enterprises — in service of the National Quantum Mission.",
      col1: "Company", col2: "Explore",
      copyright: "© 2026 QSafe India Pvt. Ltd. All rights reserved.",
      disclaimerLabel: "Legal Disclaimer",
      disclaimer: "QSafe India acts solely as an authorized sales and business consulting partner for principal quantum security technology providers. We do not manufacture, design, or own the proprietary rights to any software or hardware solutions. All business operations are executed under strict contractual agreements with our principal partners. Our strategic objective is to support India's national quantum security initiatives by facilitating the transition of public and private enterprises to future-proof, quantum-safe infrastructure.",
      place: "Gurgaon • Bharat",
    },
  },

  hi: {
    nav: {
      about: "हमारे बारे में", mission: "मिशन", whatWeDo: "हम क्या करते हैं", roadmap: "रोडमैप",
      nqm: "NQM हब", contact: "संपर्क करें", demo: "डेमो का अनुरोध करें", news: "समाचार",
    },
    news: {
      eyebrow: "साइबर समाचार डेस्क",
      titleA: "भारत का साइबर मोर्चा, ", titleB: "सीधे नज़र में।",
      sub: "हमारे स्वचालित समाचार एजेंट द्वारा चुनी गई भारतीय और वैश्विक खबरें — हर 48 घंटे में ताज़ा।",
      readMore: "पूरी खबर पढ़ें", tickerLabel: "ताज़ा साइबर समाचार",
      filterAll: "सभी समाचार", filterQuantum: "केवल क्वांटम",
      updatedA: "अपडेट", refreshNote: "हर 48 घंटे में ऑटो-रिफ्रेश",
      mAgo: " मिनट पहले", hAgo: " घंटे पहले", dAgo: " दिन पहले",
      empty: "समाचार लाए जा रहे हैं — कुछ देर बाद देखें।",
    },
    hero: {
      badge1: "भारत के राष्ट्रीय क्वांटम मिशन के साथ संरेखित",
      badge2: "क्वांटम युग के लिए विश्वास",
      l1: "क्या आप सुरक्षित हैं", l2: "कल के डिजिटल खतरों से?", l3: "क्या आपकी क्वांटम सुरक्षा तैयार है?",
      sub: "क्यूसेफ इंडिया पोस्ट-क्वांटम क्रिप्टोग्राफी सॉफ़्टवेयर और क्वांटम की डिस्ट्रीब्यूशन (QKD) हार्डवेयर का पुनर्विक्रय व तैनाती करता है — सरकारी विभागों, रक्षा, PSUs और निजी उद्यमों को क्वांटम युग के डिजिटल खतरों के लिए तैयार करता है।",
      cta1: "क्वांटम समाधान देखें", cta2: "NQM अनुपालन ब्रीफ़",
      s1v: "राष्ट्रीय क्वांटम मिशन बजट", s2v: "FIPS 203 / 204 / 205 संरेखित", s3v: "PSUs, मंत्रालय और निजी उद्यम",
    },
    cd: {
      badge: "भारत की क्वांटम-सुरक्षित समयसीमा",
      title: "Q-Day की उलटी गिनती · ~2030",
      years: "वर्ष", days: "दिन", hours: "घंटे", mins: "मिनट", secs: "सेकंड",
      bodyA: "आज के एन्क्रिप्शन को तोड़ने वाले क्वांटम कंप्यूटर का एक रूढ़िवादी अनुमान। भारत की महत्वपूर्ण बुनियादी संरचना को ",
      bodyB: "2029",
      bodyC: " तक क्वांटम-लचीला होना है (DST सलाहकार रोडमैप)। सटीक तिथि कोई नहीं जानता — ",
      bodyD: "और यही असली मुद्दा है।",
      link: "भारत का आगामी रोडमैप देखें",
    },
    marquee: {
      items: ["क्वांटम युग के लिए विश्वास", "राष्ट्रीय क्वांटम मिशन संरेखित", "पोस्ट-क्वांटम क्रिप्टोग्राफी", "QKD हार्डवेयर पुनर्विक्रय", "PSU और रक्षा अनुपालन", "निजी क्षेत्र के लिए तैयार", "MEITY प्रोटोकॉल", "ज़ीरो-ट्रस्ट क्वांटम मेश"],
    },
    about: {
      eyebrow: "क्यूसेफ इंडिया के बारे में",
      titleA: "क्वांटम नवाचार और ",
      titleB: "भारत के सार्वजनिक व निजी क्षेत्र",
      titleC: " के बीच का सेतु।",
      sub: "क्यूसेफ इंडिया का एक ही उद्देश्य है: विश्व-स्तरीय क्वांटम सुरक्षा को प्रयोगशाला से उन नेटवर्कों तक पहुँचाना जिन पर देश चलता है। हम सरकारी मंत्रालयों, रक्षा प्रतिष्ठानों, सार्वजनिक क्षेत्र के उपक्रमों (PSUs) और निजी उद्यमों की सेवा करने वाले विशेषज्ञ पुनर्विक्रेता और एकीकरण भागीदार हैं। क्वांटम युग के लिए विश्वास।",
      p1t: "आधिकारिक OEM पुनर्विक्रेता",
      p1d: "स्वदेशी और वैश्विक क्वांटम-सुरक्षा OEMs के प्रमाणित चैनल भागीदार — सार्वजनिक और निजी क्षेत्र के नेटवर्कों के लिए QKD सिस्टम, HSM और PQC सॉफ़्टवेयर सूट।",
      p2t: "सहज खरीद प्रक्रिया",
      p2d: "GeM पोर्टल के लिए तैयार, PSU टेंडर विशेषज्ञता और सरकारी खरीदारों के लिए RFP सहायता — साथ ही निजी उद्यमों के लिए तीव्र, लचीली वाणिज्यिक प्रक्रिया।",
      badgeA: "NQM लक्ष्य जिसकी ओर", badgeB: "हम निर्माण कर रहे हैं",
    },
    mission: {
      eyebrow: "हमारा मिशन",
      titleA: "एक ", titleB: "क्वांटम-सुरक्षित भारत", titleC: " का घोषणापत्र।",
      sub: "चार प्रतिबद्धताएँ जो क्यूसेफ इंडिया के हर पुनर्विक्रय, तैनाती और सुरक्षा को नियंत्रित करती हैं — राष्ट्रीय क्वांटम मिशन के दशक के लिए लिखी गईं।",
      chapter: "अध्याय",
      ch: [
        { title: "सार्वभौमिक क्रिप्टोग्राफिक सुरक्षा", desc: "Q-Day आने से पहले भारत की रणनीतिक संपत्तियों — बिजली ग्रिड, रक्षा नेटवर्क, वित्तीय प्रणालियों — को हार्वेस्ट-नाउ-डिक्रिप्ट-लेटर हमलों से सुरक्षित करना।" },
        { title: "स्वदेशी QKD हार्डवेयर पहुँच", desc: "पारदर्शी, अनुपालन-युक्त पुनर्विक्रय चैनलों के माध्यम से प्रमाणित फ़ाइबर और फ्री-स्पेस QKD सिस्टम हर PSU तक पहुँचाना।" },
        { title: "चरणबद्ध NQM 2031 ट्रांज़िशन", desc: "महत्वपूर्ण सूचना बुनियादी संरचना में NIST-अनुमोदित पोस्ट-क्वांटम एल्गोरिदम को मापित, ऑडिट-योग्य रोडमैप पर लागू करना।" },
        { title: "ज़ीरो-ट्रस्ट क्वांटम मेश", desc: "मंत्रालयों, PSUs और रक्षा कमांड को अभेद्य क्वांटम-सुरक्षित संचार नेटवर्क में जोड़ना — डिज़ाइन से ही लचीला।" },
      ],
    },
    wwd: {
      eyebrow: "हम क्या करते हैं",
      titleA: "दो विषय। एक ही परिणाम: ", titleB: "क्वांटम लचीलापन।",
      sub: "हर समझौता हमारे OEM भागीदारों के प्रमाणित हार्डवेयर और सॉफ़्टवेयर को उस खरीद-दक्षता के साथ जोड़ता है जिसकी मांग भारत के सार्वजनिक और निजी क्षेत्र करते हैं।",
      c1t: "QKD हार्डवेयर पुनर्विक्रय",
      c1d: "बिजली, ऊर्जा और रक्षा PSUs — तथा निजी डेटा-सेंटर, दूरसंचार और BFSI संचालकों — के लिए QKD सिस्टम का संपूर्ण पुनर्विक्रय और तैनाती। फ़ाइबर-आधारित और फ्री-स्पेस लिंक, ट्रस्टेड-नोड आर्किटेक्चर, इंस्टॉलेशन और AMC सहायता शामिल।",
      c2t: "PQC सॉफ़्टवेयर सूट",
      c2d: "NIST FIPS 203/204/205 एल्गोरिदम लागू करने वाली पोस्ट-क्वांटम क्रिप्टोग्राफी लाइब्रेरी, API गेटवे और VPN ओवरले — सरकारी और निजी उद्यम बुनियादी संरचना दोनों के लिए।",
    },
    roadmap: {
      eyebrow: "भारत का आगामी रोडमैप",
      titleA: "दो ट्रैक। एक ", titleB: "क्वांटम-सुरक्षित राष्ट्र।",
      sub: "भारत का DST टास्क फोर्स (मई 2026) देश का पहला समेकित PQC ट्रांज़िशन रोडमैप प्रस्तुत करता है — महत्वपूर्ण बुनियादी संरचना के लिए त्वरित ट्रैक और सरकारी व निजी उद्यमों के लिए मानक ट्रैक। क्यूसेफ इंडिया दोनों को सुसज्जित करता है।",
      threats: [
        "Q-Day चेतावनी — क्वांटम कंप्यूटर तीन वर्षों के भीतर आज की पब्लिक-की क्रिप्टोग्राफी तोड़ सकते हैं (IonQ CEO, दावोस 2026, DST रिपोर्ट में उद्धृत)",
        "कार्यकारी पाँच वर्षों के भीतर क्वांटम-संचालित साइबर हमलों की उम्मीद करते हैं — अधिकांश संगठनों के पास कोई योजना नहीं (Bain & Co.)",
        "हार्वेस्ट-नाउ-डिक्रिप्ट-लेटर और ट्रस्ट-नाउ-फोर्ज-लेटर — आज एन्क्रिप्ट किया गया डेटा पहले से ही जोखिम में है",
      ],
      cii: {
        label: "CII ट्रैक",
        desc: "महत्वपूर्ण सूचना बुनियादी संरचना के लिए त्वरित ट्रांज़िशन — रक्षा, बिजली, दूरसंचार, ISRO, DRDO, ONGC, बैंकिंग कोर।",
        milestones: [
          { title: "सूचीकरण, QRA और पायलट", points: ["क्वांटम गवर्नेंस और क्रॉस-फंक्शनल टीमें गठित करें", "क्रिप्टो इन्वेंटरी + आपूर्तिकर्ताओं से CBOM", "मोस्का प्रमेय से क्वांटम जोखिम विश्लेषण", "उच्च-प्राथमिकता सिस्टमों के सैंडबॉक्स पायलट"] },
          { title: "उच्च-प्राथमिकता लचीलापन", points: ["कोई नई केवल-क्लासिकल तैनाती नहीं", "PQC/हाइब्रिड PKI प्रमाणपत्र और हस्ताक्षर", "HSM, KMS और क्रिप्टो लाइब्रेरी अपग्रेड", "सभी विक्रेताओं से CBOM अनिवार्य"] },
          { title: "पूर्ण क्वांटम लचीलापन", points: ["समस्त-उद्यम PQC/हाइब्रिड ट्रांज़िशन", "आंतरिक PQC-केवल ट्रस्ट चेन", "सभी डिजिटल हस्ताक्षर PQC एल्गोरिदम पर", "निरंतर आश्वासन और क्रिप्टो-चपलता"] },
        ],
      },
      ent: {
        label: "एंटरप्राइज़ ट्रैक",
        desc: "महत्वपूर्ण बुनियादी संरचना से परे सरकारी विभागों और निजी उद्यमों के लिए मानक समयसीमा।",
        milestones: [
          { title: "सूचीकरण, QRA और पायलट", points: ["नेतृत्व, क्रिप्टो इन्वेंटरी और प्राथमिकताकरण", "उच्च-प्राथमिकता सिस्टमों का ट्रांज़िशन शुरू"] },
          { title: "उच्च-प्राथमिकता लचीलापन", points: ["क्रिप्टो-चपलता को संस्थागत करें", "विक्रेताओं से CBOM अनिवार्य"] },
          { title: "पूर्ण क्वांटम लचीलापन", points: ["समस्त-उद्यम PQC अपनाना", "निरंतर आश्वासन और सतत चपलता"] },
        ],
      },
      tiersTitle: "हर संगठन के लिए तात्कालिकता समान नहीं है",
      tiers: [
        { title: "तत्काल अपनाने वाले (CII)", desc: "सबसे लंबी डेटा शेल्फ-लाइफ और सबसे धीमी रीफ्रेश साइकिल — क्वांटम-सक्षम विरोधियों से अस्तित्वगत जोखिम।" },
        { title: "सामान्य अपनाने वाले (एंटरप्राइज़)", desc: "मध्यम जोखिम अवधि, पर बड़े अटैक सरफेस और विविध विक्रेता परिस्थितिकी।" },
        { title: "प्रौद्योगिकी विक्रेता", desc: "आपूर्ति-पक्ष की कुंजी — PQC-तैयार उत्पादों के बिना कोई भी ट्रांज़िशन संभव नहीं। FY 2027–28 से CBOM प्रस्तुतियाँ सलाहकार।" },
      ],
      fitLabel: "क्यूसेफ इंडिया कहाँ खड़ा है",
      fitBody: "चाहे आप 2027–2029 ट्रैक पर महत्वपूर्ण बुनियादी संरचना चलाते हों या 2028–2033 ट्रैक पर निजी उद्यम — हम प्रमाणित QKD हार्डवेयर, PQC सॉफ़्टवेयर और खरीद विशेषज्ञता प्रदान करते हैं ताकि आप हर मील के पत्थर से आगे रहें।",
      fitCta: "अपनी ट्रांज़िशन योजना बनाएं",
      statsV: ["NQM बजट 2023–2031", "IISc · IIT-M · IIT-B · IIT-D", "शोधकर्ता · 43 संस्थान", "NIST मानक: FIPS 203/204/205 + 206 मसौदा"],
      disclaimer: "सारांश DST, भारत सरकार की \"Implementation of Quantum Safe Ecosystem in India: Report of the Task Force\" (मई 2026) पर आधारित। रोडमैप सलाहकार है; बाध्यकारी दायित्व क्षेत्रीय नियामकों के माध्यम से लागू होते हैं।",
    },
    nqm: {
      eyebrow: "राष्ट्रीय क्वांटम मिशन हब",
      titleA: "भारत का क्वांटम दशक — ", titleB: "मानचित्रित।",
      sub: "NQM भारत को क्वांटम शक्ति बनाने के लिए ₹6,003.65 करोड़ (2023–2031) समर्पित करता है। जानिए इसका आपके संगठन के लिए क्या अर्थ है, और आप कितने तैयार हैं।",
      timeline: [
        "कैबिनेट ने राष्ट्रीय क्वांटम मिशन को मंजूरी — ₹6,003.65 करोड़, DST के अधीन।",
        "चार T-Hubs सक्रिय: IISc, IIT मद्रास, IIT बॉम्बे, IIT दिल्ली।",
        "ट्रस्टेड-नोड फ़ाइबर पर अंतर-शहर QKD पायलट; CII के लिए PQC दिशानिर्देश।",
        "50–100 क्यूबिट सिस्टम लक्ष्य; उपग्रह QKD ग्राउंड स्टेशन स्थापित।",
        "क्वांटम-सुरक्षित नेटवर्क 2,000 किमी तक; मिशन क्षितिज पूर्ण।",
      ],
      facts: [
        { title: "MeitY और CERT-In दिशा", desc: "सलाहकार मंत्रालयों और CII संचालकों से क्रिप्टोग्राफी सूचीकरण और PQC ट्रांज़िशन योजना का आग्रह करते हैं।" },
        { title: "चार थीमैटिक हब", desc: "क्वांटम कंप्यूटिंग (IISc), क्वांटम संचार (IIT मद्रास), क्वांटम सेंसिंग (IIT बॉम्बे) और क्वांटम मटेरियल्स (IIT दिल्ली) मिशन की रीढ़ हैं।" },
      ],
      calc: {
        title: "क्वांटम तैयारी स्कोर",
        desc: "अपने संगठन की क्वांटम तैयारी का अनुमान लगाने के लिए अपना क्षेत्र और वर्तमान स्थिति चुनें।",
        sectorLabel: "क्षेत्र",
        sectors: ["रक्षा और रणनीतिक", "बिजली और ऊर्जा", "बैंकिंग और वित्त", "दूरसंचार", "परिवहन और रेलवे"],
        posture: ["हम क्रिप्टोग्राफिक बिल ऑफ मटेरियल्स (CBOM) रखते हैं", "कुंजियाँ पहले से प्रमाणित HSMs में हैं", "PQC / QKD पायलट चल रहा है या बजट में है"],
        button: "मेरा स्कोर निकालें",
        critical: "गंभीर जोखिम", transitioning: "ट्रांज़िशन में", ready: "क्वांटम-तैयार दिशा",
        note: "केवल सांकेतिक अनुमान। औपचारिक CBOM-आधारित मूल्यांकन के लिए क्यूसेफ इंडिया से बात करें।",
      },
      mosca: {
        title: "मोस्का की असमानता",
        desc: "देर होने का गणित। यदि X + Y > Z, तो आज के डेटा की रक्षा की समय-सीमा पहले ही बीत चुकी है।",
        xLabel: "X · डेटा गोपनीयता अवधि (वर्ष)",
        yLabel: "Y · ट्रांज़िशन समय (वर्ष)",
        zLabel: "Z · Q-Day तक शेष समय (~2030)",
        vs: "बनाम",
        risk: "समय-सीमा बंद — अभी शुरू करें",
        safe: "समय-सीमा खुली — फिलहाल",
        note: "स्लाइडर खिसकाएँ: आपका डेटा कितने समय तक गोपनीय रहना चाहिए, और ट्रांज़िशन में वास्तव में कितना समय लगेगा?",
      },
    },
    contact: {
      eyebrow: "संपर्क करें",
      titleA: "अपनी ", titleB: "क्वांटम-सुरक्षित यात्रा", titleC: " शुरू करें।",
      sub: "अपनी आवश्यकता बताएं — हार्डवेयर, सॉफ़्टवेयर या टेंडर सहायता — हमारी टीम एक कार्यदिवस में उत्तर देगी, चाहे आप PSU हों, मंत्रालय या निजी उद्यम।",
      name: "पूरा नाम", email: "कार्यालयी ईमेल", org: "संगठन प्रकार", needs: "आवश्यकता क्षेत्र", message: "संक्षिप्त आवश्यकता / RFP संदर्भ",
      namePh: "डॉ. अनन्या शर्मा", emailPh: "name@organisation.com",
      msgPh: "उदा. 40 किमी मौजूदा फ़ाइबर पर दो डेटा सेंटरों के बीच QKD लिंक…",
      orgs: ["PSU", "रक्षा", "मंत्रालय / विभाग", "अनुसंधान संस्थान", "निजी उद्यम"],
      needsList: ["QKD हार्डवेयर", "PQC सॉफ़्टवेयर", "RFP सहायता", "निजी नेटवर्क सुरक्षा"],
      submit: "आवश्यकता भेजें",
      toast: "आवश्यकता दर्ज — हमारी टीम शीघ्र संपर्क करेगी।",
      error: "कुछ गड़बड़ हुई — कृपया पुनः प्रयास करें।",
      successTitle: "आवश्यकता प्राप्त हुई।",
      successA: "धन्यवाद, ", successB: "। हमारी टीम आपसे ", successC: " पर शीघ्र संपर्क करेगी।",
      reset: "एक और आवश्यकता भेजें",
      officeTitle: "बिक्री कार्यालय",
      addr: ["क्यूसेफ इंडिया प्रा. लिमिटेड", "सेक्टर 30, गुड़गांव,", "हरियाणा — 122002"],
      helpdesk: "संपर्क: +91 98100 32815",
      respLabel: "उत्तर की प्रतिबद्धता",
      respBody: "सभी सरकारी, PSU और निजी-क्षेत्र की पूछताछ का उत्तर एक कार्यदिवस के भीतर। गोपनीय आवश्यकताएँ अनुरोध पर सुरक्षित चैनलों से संभाली जाती हैं।",
      gemLabel: "GeM पंजीकृत पुनर्विक्रेता",
      gemBody: "मंत्रालयों, विभागों और PSUs की सीधी खरीद के लिए Government e-Marketplace पर सूचीबद्ध — निजी उद्यमों के लिए वाणिज्यिक शर्तों के साथ।",
    },
    legal: {
      eyebrow: "कानूनी",
      titleA: "अस्वीकरण और ", titleB: "दायरे की सीमा",
      sub: "वे शर्तें जिनके अधीन क्यूसेफ इंडिया कार्य करता है — इस साइट पर प्रवेश से पहले हर आगंतुक द्वारा स्वीकार की जाती हैं।",
      note: "यह अस्वीकरण हर आगंतुक को आगमन पर दिखाया जाता है और इस वेबसाइट की उपयोग-शर्तों का हिस्सा है। अनुबंध या अनुपालन संबंधी प्रश्नों के लिए office@qsafeindia.com पर लिखें।",
    },
    disclaimer: {
      title: "अस्वीकरण और दायरे की सीमा",
      clauses: [
        { title: "व्यवसाय की प्रकृति और गैर-निर्माण खंड", body: "क्यूसेफ इंडिया पूर्णतः एक अधिकृत रणनीतिक व्यावसायिक परामर्श और बिक्री मध्यस्थ के रूप में कार्य करता है। हम किसी भी हार्डवेयर, सॉफ़्टवेयर या क्रिप्टोग्राफिक उत्पाद की स्वामित्व डिज़ाइन, विकास, इंजीनियरिंग या निर्माण में संलग्न नहीं हैं।" },
        { title: "प्रिंसिपल-एजेंट संचालन", body: "हमारे व्यावसायिक संचालन प्रमुख मूल उपकरण निर्माताओं (OEMs) और प्रधान साइबर सुरक्षा प्रौद्योगिकी डेवलपर्स के साथ बाध्यकारी वाणिज्यिक अनुबंधों, चैनल भागीदारी समझौतों और गैर-प्रकटीकरण समझौतों (NDAs) द्वारा सख्ती से शासित हैं। हम सार्वजनिक (B2G) और निजी (B2B) दोनों क्षेत्रों में अपने प्रमुख भागीदारों की ओर से ग्राहक अधिग्रहण, बाज़ार विस्तार और प्रौद्योगिकी तैनाती की सुविधा के लिए केवल अधिकृत बिक्री सलाहकार के रूप में कार्य करते हैं।" },
        { title: "रणनीतिक संरेखण और मिशन", body: "हमारा कॉर्पोरेट उद्देश्य मूल रूप से भारत सरकार के राष्ट्रीय क्वांटम मिशन (NQM) और संबद्ध राष्ट्रीय साइबर सुरक्षा निर्देशों के साथ संरेखित है। हम दीर्घकालिक डिजिटल लचीलापन सुनिश्चित करने के लिए महत्वपूर्ण बुनियादी संरचना और वाणिज्यिक उद्यमों में भविष्य-तैयार, क्वांटम-सुरक्षित क्रिप्टोग्राफिक समाधानों को अपनाने की सुविधा के लिए समर्पित हैं।" },
      ],
      agree: "मैं सहमत हूँ — आगे बढ़ें",
      note: "हर बार साइट खोलने पर यह स्वीकृति मांगी जाती है।",
    },
    footer: {
      tagline: "क्वांटम युग के लिए विश्वास",
      body: "क्यूसेफ इंडिया सरकार, रक्षा, सार्वजनिक क्षेत्र के उपक्रमों और निजी उद्यमों के लिए क्वांटम सुरक्षा सॉफ़्टवेयर और हार्डवेयर का पुनर्विक्रय व तैनाती करता है — राष्ट्रीय क्वांटम मिशन की सेवा में।",
      col1: "कंपनी", col2: "एक्सप्लोर",
      copyright: "© 2026 क्यूसेफ इंडिया प्रा. लिमिटेड। सर्वाधिकार सुरक्षित।",
      disclaimerLabel: "कानूनी अस्वीकरण",
      disclaimer: "क्यूसेफ इंडिया प्रमुख क्वांटम सुरक्षा प्रौद्योगिकी प्रदाताओं का केवल अधिकृत बिक्री एवं व्यावसायिक परामर्श भागीदार है। हम किसी भी सॉफ़्टवेयर या हार्डवेयर समाधान के निर्माता, डिज़ाइनर या स्वामित्व अधिकार धारक नहीं हैं। सभी व्यावसायिक संचालन हमारे प्रमुख भागीदारों के साथ सख्त अनुबंधों के अधीन किए जाते हैं। हमारा रणनीतिक उद्देश्य सार्वजनिक और निजी उद्यमों को भविष्य-सुरक्षित, क्वांटम-सुरक्षित बुनियादी संरचना की ओर ले जाकर भारत की राष्ट्रीय क्वांटम सुरक्षा पहलों का समर्थन करना है।",
      place: "गुड़गांव • भारत",
    },
  },
};
